var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:[
		_vm.$s.Notice,
		_vm.$s[("type_" + _vm.type)],
		_vm.$s[("variant_" + _vm.variant)] ]},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:_vm.$s.IconContentWrapper},[_c('div',{class:_vm.$s.IconAligner},[_c(_vm.iconComponent,{tag:"component",class:_vm.$s.Icon,attrs:{"inline":""}})],1),_vm._v(" "),_c('div',[_vm._t("default")],2)]),_vm._v(" "),(_vm.showActions)?_c('div',{class:_vm.$s.ActionsWrapper},[_vm._t("actions")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }